module.exports = "/shifts/components/filters/optionsFilterComponent-922fd1.html";